import React, { Component } from 'react';
import './OEMPartner.scss';
import ContentTemplate from '../ContentTemplate/ContentTemplate';
import Constants from '../Constants';
import CollapsibleContent from "../CollapsibleContent/CollapsibleContent";
import CodeSnippetTemplate from "../CodeSnippetTemplate/CodeSnippetTemplate";
import {CodeSnippetLanguages} from "../CodeSnippetTemplate/CodeSnippetLanguages";
import CodeSnippet from "../../model/CodeSnippet";
import Auth0App from "../../assets/images/seller-paid-1.png";
import OEMRedirectFlow from "../../assets/images/oem_path.png";
import imgSorry from "../../assets/images/sorry-snapshot.png";
import imgSnapshot from "../../assets/images/snapshot-dealer.png";
import { Link } from 'react-router-dom';
import LogInMock from "../../assets/images/login-mock.png";
import imgLogoWhite from "../../assets/images/CARFAX_logo_R_white.svg";
import imgLogoBlack from "../../assets/images/CARFAX_logo_R_black.svg";
import {Image} from "react-bootstrap";
import imgDemoMock from "../../assets/images/carfax-connect-demo-mock.png";
import imgPillarHover from "../../assets/images/accident-pillar-hover.png";
import imgFourPillars from "../../assets/images/four-pillars.png";
import {HashLink} from "react-router-hash-link";
import PartnerPortalApplications from "../../assets/images/partner-portal-applications.png";

export default class OEMPartner extends Component<any, any> {

    private oemNavLinks: Map<string, string> = new Map([
        ["#oem-paid-reports", "OEM Paid Reports"],
        ["#api-schema", "API Schema"],
        ["#oem-paid-prerequisites", "Prerequisites"],
        ["#step-1-access-token", "Step 1 - Access Token"],
        ["#step-2-graphql-query", "Step 2 - GraphQL Mutation"],
        ["#step-3-send-request", "Step 3 - Send Request"],
        ["#cc-carfax-report-links", "CARFAX Report Link"],
        ["#four-pillars", "Four Pillars"],
        ["#oem-paid-snapshot", "Snapshot"],
        ["#cc-vehicle-information", "Vehicle Information"],
        ["#carfax-branding", "Carfax Branding"]
    ]);

    private oemStoplightNavLinks: Map<string, string> = new Map([
        ["#overview", "Overview"],
        ["#prerequisites", "Prerequisites" ],
        ["#authentication", "Authentication"],
        ["#sending-a-request", "Sending a Request"],
        ["#oem-carfax-branding", "CARFAX Branding"]
    ]);

    private oemInstantCarfaxReportNavLinks: Map<string, string> = new Map([
        ["#instant-carfax-report", "Instant CARFAX Report"],
        ["#ada-compliance", "ADA Compliance / Accessibility"],
        ["#oem-icr-api-schema", "API Schema"],
        ["#oem-icr-prerequisites", "Prerequisites"],
        ["#step-1-authenticate-with-carfax", "Step 1 - Authenticate with CARFAX"],
        ["#step-2-oem-icr-access-token", "Step 2 - Get an Access Token"],
        ["#step-3-oem-icr-send-request", "Step 3 - Send a Request"],
    ]);

    private navLinks: Map<string, Map<string, string>> = new Map<string, Map<string, string>>([
        ["OEM", this.oemNavLinks],
        ["OEM Stoplight", this.oemStoplightNavLinks],
        ["OEM Instant CARFAX Report", this.oemInstantCarfaxReportNavLinks]
    ]);

    public render() {
        return( 
            <div className={"oem"}>
                <ContentTemplate
                    pageTitle="OEM"
                    navlinksMap={this.navLinks}
                    content={this.getContentHtml()}
                />
            </div>
        );
    } 

    private getContentHtml(): JSX.Element {
        return (
            <div className={"content-container"}>
                <h1 id="blah">OEM</h1>
                <section>
                    <h3 id="oem-paid-reports">OEM Paid Reports</h3>
                    <p>
                        The OEM Paid Report option via Connect allows CARFAX Reports to be displayed on vehicles able to be certified in 
                        dealer facing CPO applications.  These CARFAX Reports may be viewed by any dealer or user of an OEM hosted CPO 
                        application as a benefit to help meet the CPO criteria of the OEM. Some guidelines for how this option is to be used:
                        <ul>
                            <li>                                
                                The partner integrates the CARFAX Connect API into the application that will be used by dealers.
                            </li>
                            <li>
                               The API should be associated with each specific VIN listing with a corresponding "View
                                CARFAX Report" link and CARFAX logo or other agreed upon graphic.
                                See the <a href={Constants.DEALER_PAGE_URL + "#carfax-branding"}>CARFAX Branding </a>section for details.
                            </li>
                            <li>
                                When the link/logo is clicked, the partner’s application sends a GraphQL request to CARFAX with all the 
                                necessary parameters and headers.  
                            </li>
                            <li>
                                In this case, the VHR is run under the OEM account initially but is also associated to the dealer through the 
                                passing of the dealer's franchise ID in the franchiseNumber field when a query is made.
                            </li>
                            <li>
                                CARFAX initiates the logic and then returns the report URL that displays the CARFAX Report in a new tab or window.
                            </li>
                        </ul>
                    </p>
                </section>
                <hr/>

                <section>
                    <h3 id={"api-schema"}>API Schema</h3>
                    <p>
                        For the purposes of this guide, the following Schema will be used:
                        <br/>
                        <CollapsibleContent content={
                            <CodeSnippetTemplate codeSnippets={[
                                new CodeSnippet(
                                    CodeSnippetLanguages.GRAPHQL,
                                    "GraphQL",
                                    `extend type Mutation{
    purchaseOEMDealerReport(vin: Vin, franchiseNumber: String): DealerReport
}
type DealerReport{
    # Link to the CARFAX report
    carfaxLink: DealerReportLink

    # Four key characteristics consumers consider when evaluating a vehicle
    fourPillars: FourPillars
    
    # Key used to render a CARFAX snapshot
    snapshotKey: String
 
    # Expiration for the CARFAX report
    expiresAt: Timestamp
    
    # Basic information about the vehicle
    vehicle: Vehicle
}

# Link to the CARFAX report
type DealerReportLink {
    url: Url!
}

type FourPillars {
    # Information about any known accidents
    accident: AccidentHistoryPillarWrapper

    # Indicates whether or not a vehicle had multiple owners
    owner: OwnerHistoryPillarWrapper
    
    # Indicates whether or not a vehicle was personal or commercial
    useType: UseHistoryPillarWrapper
    
    # How many service records a vehicle has
    serviceRecord: ServiceHistoryPillarWrapper
}

type AccidentHistoryPillarWrapper{
    # The URL to the SVG icon
    iconUrl: Url!

    # The text to be displayed next to the icon
    iconText: String

    # Indicates whether the vehicle has any known accidents
    hasAccidents: Boolean

    # A reminder of the display order for the accident pillar
    position: Int!
}

type OwnerHistoryPillarWrapper {
    # The URL to the SVG icon
    iconUrl: Url!

    # The text to be displayed next to the icon
    iconText: String

    # Indicates whether this vehicle had only one owner
    isOneOwner: Boolean!

    # A reminder of the display order for the owner pillar
    position: Int!
}

type UseHistoryPillarWrapper {
    # The URL to the SVG icon
    iconUrl: Url!

    # The text to be displayed next to the icon
    iconText: String!

    # Indicates if this was a personal-use vehicle
    isPersonalUse: Boolean!

    # A reminder of the display order for the use-type pillar
    position: Int!
}

type ServiceHistoryPillarWrapper {
    # The URL to the SVG icon
    iconUrl: Url!

    # The text to be displayed next to the icon
    iconText: String!

    # How many service records this vehicle has
    recordCount: Int!

    # A reminder of the display order for the service pillar
    position: Int!
}

# Vehicle Information
type Vehicle {
    vin: Vin
}

# Instant in time (not local)
type Timestamp {
    # UNIX timestamp; seconds elapsed since the UNIX epoch, 1970-01-01T00:00:00Z, neglecting leap seconds
    unix: Seconds!
 
    # Milliseconds elapsed since the UNIX epoch, 1970-01-01T00:00:00Z, neglecting leap seconds
    unixMillis: Milliseconds!
 
    # Date-time string in RFC 3339/ISO 8601 format, such as '2019-02-01T13:22:33Z'
    rfc: RfcTimestamp!
}

# Vehicle Identification Number; 17 uppercase alphanumeric characters
scalar Vin
 
# An absolute URL, with encoding applied as needed
scalar Url
 
# RFC 3339 date & time (an ISO 8601 profile) such as '2019-02-01T13:22:33Z'
scalar RfcTimestamp
 
# Integer in the JavaScript safe range -(2^53 - 1) to 2^53 - 1
scalar IntJs
 
# Seconds represented as an IntJs scalar
scalar Seconds
 
# Milliseconds represented as an IntJs scalar
scalar Milliseconds
 
}

`
                                )
                            ]}/>
                        }/>
                    </p>
                </section>
                <hr />

                <section>
                    <h3 id={"oem-paid-prerequisites"}>Prerequisites</h3>
                    <p>
                        Before you can authenticate and start running queries on CARFAX Connect, you must have
                        a <strong>Client Credentials Application</strong> set up in the Partner Portal.
                        Log in to the CARFAX Partner Portal using your developer credentials.
                        You will need to retrieve the Client ID and Client Secret of a Client Credentials application.
                        <ul>
                            <li>
                                If you do not have a Client Credentials application assigned, you can create one using
                                the New Application button.
                                A popup will appear, allowing you to name the new application.
                            </li>
                        </ul>
                    </p>
                    <p className={"text-center"}>
                        <img
                            src={Auth0App}
                            width="647px"
                            alt="Partner Portal: Applications Screen"
                        />
                    </p>
                    <ul>
                        <li>
                            Upon clicking Create, the new application will appear in your list of applications.
                        </li>
                    </ul>
                </section>
                <hr/>

                <section>
                    <h3 id={"step-1-access-token"}>Step 1 - Get an Access Token</h3>
                    <p>
                        CARFAX Connect follows the OAuth 2.0 authentication process. You'll be using the Client
                        Credentials flow to get an Access Token.
                        Use your Client ID and Client Secret to retrieve an access token with an HTTP POST request
                        to <i>
                        https://auth.carfax.com/oauth/token</i>. You can use the following cURL to request an access
                        token.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(CodeSnippetLanguages.MARKUP, 'cURL',
                                `curl -XPOST \\
    -H "Content-type: application/json" \\
    -d '{"client_id":"YOUR_CLIENT_ID","client_secret":"YOUR_CLIENT_SECRET","audience":"https://connect.carfax.com","grant_type":"client_credentials"}' 'https://auth.carfax.com/oauth/token'
`)
                        ]}/>
                    </p>
                    <p>The response will be similar to the response below. As you can see your access token is
                        under <i>access_token</i> field.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(CodeSnippetLanguages.JSON, 'JSON',
                                JSON.stringify(
                                    {
                                        "access_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9....",
                                        "scope": "read:client_grants create:client_grants ... ",
                                        "expires_in": 86400,
                                        "token_type": "Bearer"
                                    }, null, 4
                                ))
                        ]}/>
                    </p>
                    <p>
                        <strong>IMPORTANT</strong>: An access token once obtained is valid for 24 hours and should be reused until it expires.
                        Please do not fetch a new access token with each request. If coded properly we would expect to see one refresh per day if calling from a single machine or perhaps as many as 10 if using distributed machines to call Connect.
                        The expiration is identified via expires_in which is in seconds. Be sure to obtain a fresh token sufficiently far in advance to allow for network delays and clock skew.
                    </p>
                </section>
                <hr/>

                <section>
                    <h3 id={"step-2-graphql-query"}>Step 2 - Prepare the GraphQL Mutation</h3>
                    <p>

                        For the purposes of this guide, we will use the following GraphQL mutation:

                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.GRAPHQL,
                                "GraphQL",
                                `mutation{
  purchaseOEMDealerReport(vin: "2FTRX18L62CA68371", franchiseNumber: "12345") {
    dealerReport {
      carfaxLink {
        url
      }
    }      
  }
}
`
                            )
                        ]}/>
                        <p>
                            Convert your GraphQL to a JSON object. You can also use commas(,) or spaces to separate the
                            different types in the mutation instead of the newline character(\n).
                            GraphQL is very flexible when it comes to how you want to format the mutation if readability is
                            important:
                        </p>
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(CodeSnippetLanguages.JSON, 'JSON',
                                JSON.stringify({
                                    "query": "mutation{purchaseOEMDealerReport(vin:\"2FTRX18L62CA68371\", franchiseNumber: \"12345\") { dealerReport { carfaxLink { url } } } }"
                                }, null, 4))
                        ]}/>
                        For more information on sending GraphQL queries, and what type of queries CARFAX Connect
                        supports, please refer to&nbsp;
                        <Link to={Constants.SEND_QUERIES_PAGE_URL}>Sending Queries page</Link>.
                    </p>

                </section>
                <hr/>

                <section>
                    <h3 id={"step-3-send-request"}>Step 3 - Sending a request to CARFAX Connect</h3>
                    <p>
                        Now you are ready to make a request to CARFAX Connect. To start, prepare a new HTTP POST request to
                        the <i> http://connect.carfax.com/v1/graphql </i>.
                        Paste the access token from the first step into the header of the HTTP request.
                        Don't forget to put "Bearer" and then a space before the access token.
                        In the body of the request to CARFAX Connect, write your GraphQL mutation in json format from the
                        previous step.
                        Example below shows the whole request for querying a CARFAX link in cUrl format.
                    </p>
                    <p>
                        Note that the franchiseNumber should always represent the dealer's franchise ID.  
                        The franchise ID or dealer ID is assigned by the OEM uniquely to the dealer. 
                        It can be an alphanumeric value such as NY104 or 03501.
                    </p>
                                        <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(CodeSnippetLanguages.MARKUP, 'cURL',
                            `curl --request POST \\
  --url https://connect.carfax.com/v1/graphql \\
  --header 'authorization: Bearer <YOUR_ACCESS_TOKEN_HERE>' \\
  --header 'content-type: application/json' \\
  --data '{"query":"mutation{purchaseOEMDealerReport(vin:\\"JM3KE4CY0G0797189\\", franchiseNumber: \\"12345\\") { dealerReport { carfaxLink { url } } } }"}'`)
                    ]}/>
                    <p>
                        If you use the exact same mutation as the example above, the response you receive would be like:

                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.GRAPHQL,
                                "GraphQL",
                                `
{
  "data": {
    "purchaseOEMDealerReport": {
      "dealerReport": {
        "carfaxLink": {
          "url": "REPORT_URL_HERE"
        } 
      }
    }
  }
}
`
                            )
                        ]}/>
                    </p>
                    <p>Now you are all set to use your Client Credentials and query Connect to enable dealers to run OEM Paid reports.
                        For more information about the authentication, check out the <Link
                            to={Constants.AUTHENTICATION_PAGE_URL + "#client-credentials-flow"}>Client Credentials authentication flow</Link>.
                    </p>
                </section>
                <hr/>

                <section>
                    <h3 id="cc-carfax-report-links">CARFAX Report Links - Client Credentials Flow</h3>
                    <p>
                        CARFAX Report links expire after 7 days, so keep that in mind if you choose to cache them.
                        If you decide not to cache CARFAX links, you should call Connect when the user clicks the report
                        link and redirect the browser to the report URL provided.
                        You can use JavaScript or an actual HTTP redirect from your back end to send the browser to the
                        report URL. Whatever mechanism you use, ensure the redirect is not cached longer than the URL
                        expiration time.
                        If using HTTP redirects, we recommend using status 303 See Other because it will not be cached
                        and forces the browser to make a GET request to the new URL regardless of the method used in the
                        initial back end request.
                        <br/>
                        Sequence for HTTP redirect:

                        <p className={"text-center"}>
                            <img
                                src={OEMRedirectFlow}
                                width="730px"
                                alt="Partner Portal: Applications Screen"
                            />
                        </p>

                        <p>

                            You do not need to query all the fields in the queries that you send. GraphQL allows you to
                            choose only the fields (or data points) that you need and receive the response in JSON format.
                            As an example consider the mutation below:

                            <CodeSnippetTemplate codeSnippets={[
                                new CodeSnippet(
                                    CodeSnippetLanguages.GRAPHQL,
                                    "GraphQL",
                                    `
mutation($vin: Vin!, $franchiseNumber: String!) {
    purchaseOEMDealerReport(vin: $vin, franchiseNumber: $franchiseNumber) {
        dealerReport {
            carfaxLink{
                url
            }
            expiresAt {
                unix
                unixMillis
                rfc
            }
        }
    }
}`
                                )
                            ]}/>
                            In order to be more secure against injection attacks and to keep your mutation more secure, it
                            is a good practice to pass the input parameters
                            inside the <strong>Variables</strong> field instead of putting the inputs directly inside
                            the mutation:
                            <CodeSnippetTemplate codeSnippets={[
                                new CodeSnippet(
                                    CodeSnippetLanguages.GRAPHQL,
                                    "GraphQL",
                                    `{
    "vin": "2FTRX18L62CA68371",
    "franchiseNumber: "12345",
}`
                                )
                            ]}/>

                            The response for the above mutation:
                            <CodeSnippetTemplate codeSnippets={[
                                new CodeSnippet(
                                    CodeSnippetLanguages.GRAPHQL,
                                    "JSON",
                                    `
{
  "data": {
    "purchaseOEMDealerReport": {
      "dealerReport": {
        "carfaxLink": {
          "url": "https://connect.carfax.com/dir?key=AVcsf...",
          "expiresAt": {
            "unix": 1600265688,
            "unixMillis": 1600265688641,
            "rfc": "2020-09-16T14:14:48.641198Z"
          }
        }
      }
    }
  }
}`
                                )
                            ]}/>
                        </p>
                        <p>
                            The returned URL takes you to the report.

                            OEM Paid partners will always get the requested report.
                            They can access a report for any VIN without a prior explicit purchase.
                        </p>
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id="four-pillars">Four Pillars</h3>
                    <p>
                        Four Pillars is a set of four key characteristics consumers consider
                        when evaluating a vehicle:{" "}
                    </p>
                    <ol id="four-pillars-list">
                        <li>Accidents &amp; damage</li>
                        <li>Owner History (number of owners)</li>
                        <li>Use type (such as personal or commercial)</li>
                        <li>Service Record (number of service records)</li>
                    </ol>
                    <p>
                        Each pillar is represented by an icon and short text description. The
                        Four Pillars should always be displayed in this order.
                    </p>
                    <p>
                        Example Four Pillars display:
                        <br/>
                        <img src={imgFourPillars} width="512px" alt="Example Four Pillars display"/>
                    </p>
                    <p>
                        Based on the configuration set by your account manager you may be authorized to receive 1-4 pillars.
                        Use the interactive schema browser in <Link to={Constants.CONNECT_EXPLORER_URL}>Connect Explorer</Link> to see which fields are visible to you.
                    </p>
                    <p>
                        To fetch Four Pillar data points use the following purchaseOEMDealerReport mutation field:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.GRAPHQL,
                                "GraphQL",
                                `mutation{
purchaseOEMDealerReport(vin: $vin, franchiseNumber: $franchiseNumber){
  dealerReport{
    fourPillars {
      accident {
        iconUrl
        iconText
        position
        hasAccidents
      }
      owner { 
        iconUrl
        iconText
        position
        isOneOwner
      }
     useType {
        iconUrl
        iconText
        position
        isPersonalUse
      }
      serviceRecord {
        iconUrl
        iconText
        position
        recordCount      
      }
    }
    snapshotKey
  }}}`
                            )
                        ]}/>
                    </p>
                    <p>
                        Example response:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify(
                                    {
                                        data: {
                                            purchaseOEMDealerReport: {
                                                dealerReport: {
                                                    fourPillars: {
                                                        accident: {
                                                            iconUrl:
                                                                "https://partnerstatic.carfax.com/img/vhr/ico_alert.svg",
                                                            iconText: "Branded Title",
                                                            position: 1,
                                                            hasAccidents: true,
                                                        },
                                                        owner: {
                                                            iconUrl:
                                                                "https://partnerstatic.carfax.com/img/vhr/ico_owner3.svg",
                                                            iconText: "3+ Owners",
                                                            position: 2,
                                                            isOneOwner: false,
                                                        },
                                                        useType: {
                                                            iconUrl:
                                                                "https://partnerstatic.carfax.com/img/vhr/ico_personal.svg",
                                                            iconText: "Personal Use",
                                                            position: 3,
                                                            isPersonalUse: true,
                                                        },
                                                        serviceRecord: {
                                                            iconUrl:
                                                                "https://partnerstatic.carfax.com/img/vhr/ico_service.svg",
                                                            iconText: "Service History",
                                                            position: 4,
                                                            recordCount: 15,
                                                        },
                                                    },
                                                },
                                            },
                                        },
                                    },
                                    null,
                                    4
                                )
                            )
                        ]}/>
                    </p>
                    <p>
                        Every pillar has an <code>iconUrl</code> with <code>iconText</code> to
                        display alongside the icon.
                        <code>position</code> is a reminder of the display order but you do
                        not need to query it in your application because the order never
                        changes. The boolean flags <code>hasAccidents</code>,{" "}
                        <code>isOneOwner</code>, <code>isPersonalUse</code>, and the numeric{" "}
                        <code>recordCount</code> can be used to implement sorting and
                        filtering of VIN lists. The service <code>recordCount</code> can be
                        displayed near the service icon if space permits.
                    </p>
                    <p>
                        You can cache Four Pillars for faster display. You should refresh the
                        cached data at least once per day. You can also load it on demand if
                        desired, such as when a user loads a page that displays Four Pillars.
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id="oem-paid-snapshot">Snapshot</h3>
                    <p>
                        Snapshot is a simple html file generated for the client to give a
                        'snapshot' of key vehicle history information. When added to a 
                        dealer facing CPO tool, Snapshot offers these benefits:
                    </p>
                    <ul>
                        <li>
                            For all vehicles already featuring a Dealer Instant CARFAX Report,
                            dealers may now see the same data found in the header of the
                            report at all places where they engage with the vehicle in your
                            application.
                        </li>
                        <li>
                            With just a hover over the CARFAX logo, dealers can quickly see
                            the key vehicle history points for the given vehicle, allowing
                            them to make timely inventory management decisions.
                        </li>
                        <li>
                            Dealers can reference the CARFAX History-Based Value for their
                            vehicles if your agreement terms provide for this added benefit.{" "}
                        </li>
                    </ul>
                    <img src={imgSnapshot} alt="speSnapshot Example" className={"img-fluid"} width="250px"/>
                    <p>
                        Unlike the legacy Snapshot, the new Snapshot URL has a
                        Snapshot key which hides the VIN and dealer information. Here's the mutation to get Snapshot Key.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.GRAPHQL,
                                "GraphQL",
                                `mutation ($vin: Vin!, $franchiseNumber: String!) {
    purchaseOEMDealerReport(vin: $vin, franchiseNumber: $franchiseNumber) {
        dealerReport {
            snapshotKey
        }
    }
}`
                            )
                        ]}/>
                    </p>
                    <p>
                        Variables:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify({vin: "JN8AF5MR5CT116133", franchiseNumber: "12345"}, null, 4)
                            )
                        ]}/>
                    </p>
                    <p>
                        Sample response:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify(
                                    {
                                        data: {
                                            purchaseOEMDealerReport: {
                                                dealerReport: {
                                                    snapshotKey: "p5lI0fc6F52ATD-ayqZRUze_I30-6NQVyEahpAADvz4fcqX1kP6rNRvuA2JJBhC1ZDrE1dgeV7M1pBTGCWG3rVJDfY2aWSUvAmp0IpeC6tnf1oxHutKkb3s0jeUmrevT_GnG43aWAbyOlTlueofoE8fF",
                                                }
                                            },
                                        },
                                    },
                                    null,
                                    4
                                )
                            )
                        ]}/>
                    </p>
                    <p>
                        Information such as <code>{`vin`}</code>, <code>{`userId`}</code>, and{" "}
                        <code>{`dealerCompCode`}</code>
                        are embedded in the <code>{`snapshotKey`}</code> which can be used to
                        render the Snapshot data through the dealer Snapshot endpoint. The key
                        is used to ensure that the requests being made against our server are
                        authorized and can also be injected in an img or anchor tag to show
                        the Snapshot HTML.
                    </p>
                    <h4 id="including-snapshotjs">Including Snapshot.js</h4>
                    <p>
                        When implementing Snapshot, you'll need to use our hosted JavaScript
                        file:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.MARKUP,
                                "HTML",
                                '<script type="text/javascript" src="https://snapshot.carfax.com/latest/dealer-snapshot.js"></script>'
                            )
                        ]}/>
                    </p>
                    <p>
                        Generally, it should be included right before you close out your body
                        tag in your HTML document.
                    </p>
                    <h4 id="dealer-snapshot-hover-over">Dealer Snapshot Hover-Over</h4>
                    <p>
                        On a desktop application, we recognize that most existing promotions
                        will show simply a CARFAX logo or icon. Hovering over the logo/icon
                        will cause the Snapshot to render just to the side of the logo/icon.
                        Clicking on the logo/icon should open the dealer report directly.{" "}
                    </p>
                    <p>
                        Applying the bindings for the Snapshot hover-over is as easy as adding
                        only two attributes on your html element that you would like to display
                        Snapshot, when hovered over. The elements are as follows:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.MARKUP,
                                "HTML",
                                'class="carfax-dealer-snapshot-hover" data-snapshotkey="SnapshotKey"'
                            )
                        ]}/>
                    </p>
                    <p>
                        SnapshotKey = The key you will get back from the
                        Connect Dealer Report Response
                    </p>
                    <p>
                        For example, an Image tag that shows the report when hovered over
                        would follow this pattern.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.MARKUP,
                                "HTML",
                                '<img src="photo.jpg" class="carfax-dealer-snapshot-hover" data-snapshotkey="SnapshotKey"/>'
                            )
                        ]}/>
                    </p>
                    <h4 id="embedded-dealer-snapshot">Embedded Dealer Snapshot</h4>
                    <p>
                        The Dealer Snapshot may also be embedded on any page of your
                        application for easy presentation of the CARFAX vehicle history.
                        <br/>
                        The embedded Snapshot displays just as the hover-over version,
                        however, it’s not triggered by hovering over an element, and instead,
                        it’s added to the page as it loads. Just like the hover-over version
                        of Snapshot, the embedded version also allows dealers to click “View
                        the CARFAX Report” in order to see the full report.
                    </p>
                    <p>
                        The class for the embedded Snapshot is “carfax-snapshot-embedded”. You
                        will want to include the same JavaScript library whether using the
                        embedded or pop-up version of Snapshot on a page. We also recommend
                        using a <code>{`<div>`}</code> element for the embedded Snapshot to
                        ensure everything is styled appropriately.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.MARKUP,
                                "HTML",
                                'class="carfax-dealer-snapshot-embedded" data-snapshotkey="SnapshotKey"'
                            )
                        ]}/>
                    </p>
                    <p>
                        SnapshotKey = The key you will get back from the
                        Connect Dealer Report Response
                    </p>
                    <p>
                        For example, an Image tag that shows the report when hovered over
                        would follow this pattern.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.MARKUP,
                                "HTML",
                                '<div class="carfax-dealer-snapshot-embedded" data-snapshotkey="SnapshotKey"></div>'
                            )
                        ]}/>
                    </p>
                    <h4 id={"refreshing snapshot"}>Refreshing Snapshot</h4>
                    <p>
                        If you have vin data loaded after the page load has already happened, then you should
                        reload the Snapshot.js file so that any newly added snapshots show up correctly.
                        In order to do so, please trigger the 'refreshSnapshotEvent' after the Connect data has
                        finished loading. This action will enable the proper viewing of all the snapshots on the page.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JAVASCRIPT,
                                "JavaScript",
                                `const refreshSnapshotEvent = new Event('refreshCarfaxSnapshotData');

document.dispatchEvent(refreshSnapshotEvent);`
                            )
                        ]}/>
                    </p>
                    <h4 id="specs">Specs</h4>
                    <p>
                        Snapshot is built to be resized responsively but we do have the
                        following min/max sizes that we suggest you use when rendering
                        Snapshot:
                    </p>
                    <ul>
                        <li>
                            Minimum width = 250 pixels
                        </li>
                        <li>
                            Maximum width = 350 pixels (a user may enlarge it beyond this but
                            the rows will simply stretch)
                        </li>
                        <li>
                            Maximum height = 518 pixels if the Year/Make/Model shows on three
                            lines
                        </li>
                    </ul>
                    <p>
                        Please note that the final implementation of Snapshot in your
                        application shall be mutually agreed to and approved by your CARFAX
                        account manager prior to launch. We encourage you to share screen
                        shots and/or provide beta access to your application to facilitate
                        this process.
                    </p>
                    <h4 id="sorry-message">Sorry Message</h4>
                    <p>
                        Should the report be unavailable, the service be down or the request
                        not properly authenticated, the dealer will receive a “sorry” message
                        like the one below.
                        <br/>
                        <img src={imgSorry} alt="Sorry Page" width="300" height="390"/>
                    </p>
                </section>
                <hr/>

                <section>
                    <h3 id={"cc-vehicle-information"}>Vehicle Information</h3>
                    <p>
                        In GraphQL, the data for the queries is returned in the same order that it was requested.
                        Although there may be use cases where the final state of the data is not in the same order.
                        In that case, there will need to be some sort of explicit mapping for the requested data with
                        its response.
                        CARFAX Connect supports the vehicle field which can be used to get back basic Vehicle
                        information such as the VIN to map the requested data to its response:
                    </p>
                    <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(
                            CodeSnippetLanguages.GRAPHQL,
                            "GraphQL",
                            `mutation($vin: Vin!, $franchiseNumber: String!) {
    purchaseOEMDealerReport(vin: $vin, franchiseNumber: $franchiseNumber) {
        dealerReport {
            vehicle {
                vin
            }
        }
    }
}`
                        )
                    ]}/>
                    Variables:
                    <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(
                            CodeSnippetLanguages.GRAPHQL,
                            "JSON",
                            `{
    "vin": "WBANU53568CT40260",
    "franchiseNumber": "12345"
}`
                        )
                    ]}/>
                    Response:
                    <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(
                            CodeSnippetLanguages.GRAPHQL,
                            "JSON",
                            `{
  "data": {
    "purchaseOEMDealerReport": {
      "dealerReport":{
        "vehicle": {
          "vin": "WBANU53568CT40260"
        }
      }
    }
  }
}
`
                        )
                    ]}/>
                </section>
                <hr/>
                <section>
                    <h3 id="carfax-branding">CARFAX Branding</h3>
                    <p>
                        All references to CARFAX throughout partner applications should always be in all caps.
                    </p>
                    <p>
                        To ensure a consistent and clear message for dealers across partner applications please use the
                        following copy on the Settings/Admin screen where users may log in or sign out. Note the use of
                        “log in” as a verb versus “login” as a noun.
                        <br/>
                        <img src={LogInMock} width="381px" height="180px" alt="Mockup of partner app log in link"/>
                        <br/>
                        The generic screenshots below show how CARFAX may be integrated on a list level and vehicle
                        detail page in a dealer facing application. Items of note:
                    </p>
                    <ul>
                        <li>The link to the dealer report should state “View CARFAX Report” or simply “CARFAX
                            Report” if space is limited.
                        </li>
                        <li>The 2 or 4 Pillar data should be featured using the icon image URLs Connect returns in
                            the API response.
                            Use of this data on a listings page also affords the opportunity to add a sort and
                            filter option as shown on the
                            left rail in the mock.
                        </li>
                        <li>
                            Dealer Snapshot may be featured as a hover-over on a list level rendering just to the
                            left and above the
                            “View CARFAX Report” link. Snapshot may also be embedded on a detail page.
                        </li>
                        <li>
                            On a detail page the CARFAX logo should be featured with “View Report” text.
                            If space allows for the 4 Pillar data please use the icon image URLs Connect returns in
                            the API response.
                            In the example below we also show the option to post a mouse-over on each icon to
                            display the underlying copy
                            for the icon which is also returned in the API response. The appropriate CARFAX logo may
                            be downloaded here:
                            <br/><br/>
                            <a href={imgLogoWhite} target={"_blank"} rel={"noopener noreferrer"}>CARFAX Logo for use
                                on a black background</a>
                            <br/><br/>
                            <a href={imgLogoBlack} target={"_blank"} rel={"noopener noreferrer"}>CARFAX Logo for use
                                on a white background</a>
                        </li>
                    </ul>
                    <Image src={imgDemoMock} className={"img-fluid"}/>
                    <Image src={imgPillarHover} fluid className={"img-fluid"}/>
                </section>
                <h1 id="blah">OEM Stoplight</h1>
                    <h6> *Please note that Stoplight is not assigned by default to an OEM Partner. Your CARFAX Account Manager will work with you to determine if this is a suitable product for your specific use case. </h6>
                <section>
                    <h3 id="overview">Overview</h3>
                    <p>CARFAX Stoplight is a product delivered via CARFAX Connect that allows for a VIN to be checked against a set of predefined vehicle history criteria to determine if any of the events are present. A Red Light and Yellow Light set of criteria may be independently configured to allow partners to first check for major events and then subsequently moderate events.</p>
                    <p>The OEM version of Stoplight provides OEM partners with a unique tool to offer CARFAX dealers who wish to identify cars that meet the OEM defined vehicle history criteria to be certified.  To leverage this feature dealers must be enrolled in the CARFAX Advantage program and have a franchise ID associated to the OEM making the request.  </p>
                    <p>Stoplight will return a “fail” response when one or more of the defined events are present in the history of the VIN submitted or a “pass” response when no events are present. The specific underlying data points that failed or passed are not returned in the response.</p>
                    <p>Below is an example of a Red Light and Yellow Light configuration which may be used as a baseline of data sets from which to choose for your specific needs. Data may be shifted between the two sets or removed entirely. Note that Stoplight may also be configured to only use a single Red Light set of criteria which is common for OEM partners. </p>
                    <table className="table table-striped table-bordered">
                        <thead>
                        <tr>
                            <th/>
                            <th>Red Light = Major Problems</th>
                            <th>Yellow Light = Moderate Problems</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>Branded Titles</td>
                            <td>
                                Exceeds Mechanical Limits<br/>
                                Fire<br/>
                                Flood Damage<br/>
                                Hail Damage<br/>
                                Junk<br/>
                                Lemon/Buyback<br/>
                                Not Actual Mileage<br/>
                                Rebuilt/Reconstructed<br/>
                                Salvage
                            </td>
                        </tr>
                        <tr>
                            <td>Other Damage Events</td>
                            <td>
                                Fire<br/>
                                Flood/Water<br/>
                                Structural<br/>
                                Total Loss<br/>
                                Vandalism
                            </td>
                            <td>
                                Accident Reported<br/>
                                Airbag Deployed<br/>
                                Damage Reported
                            </td>
                        </tr>
                        <tr>
                            <td>Damage Severity</td>
                            <td>
                                Moderate to Severe<br/>
                                Severe
                            </td>
                            <td>
                                Very Minor<br/>
                                Minor<br/>
                                Minor to Moderate<br/>
                                Moderate
                            </td>
                        </tr>
                        <tr>
                            <td>Use Type</td>
                            <td>
                                Police<br/>
                                Taxi
                            </td>
                            <td>
                                Government<br/>
                                Rental
                            </td>
                        </tr>
                        <tr>
                            <td>Other</td>
                            <td>
                                Currently Stolen<br/>
                                Odometer Problem/Rollback<br/>
                                Reacquired by Manufacturer
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </section>
                <hr/>
                <section>
                    <h3 id="prerequisites"> Prerequisites</h3>
                    <p>Before you can authenticate and start running queries on CARFAX Connect, you must be configured by Carfax for the Stoplight service and have a <strong>Client Credentials</strong> Application set up in the Partner Portal. You can choose to use the one we provided (App Type - Client Credentials), or use one that you create.</p>
                    <p className={"text-center"}>
                        <img
                            src={PartnerPortalApplications}
                            width="647px"
                            alt="Partner Portal: Applications Screen"
                        />
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id="authentication">Authentication</h3>
                    <p>To get started a lead developer will receive an invitation to the Connect Partner Portal as noted on the <HashLink to = {Constants.AUTHENTICATION_PAGE_URL}> Authentication</HashLink> page.</p>
                    <p>Once you have access to the Partner Portal, create a Client Credentials application. With the Client Credentials application built, you next need to authenticate to receive an access token (JWT). This token will allow you to make requests to CARFAX Connect in the form of GraphQL queries to receive Stoplight information for a given VIN.</p>
                    <p>
                        <strong>IMPORTANT</strong>: An access token once obtained is valid for 24 hours and should be reused until it expires.
                        Please do not fetch a new access token with each request. If coded properly we would expect to see one refresh per day if calling from a single machine or perhaps as many as 10 if using distributed machines to call Connect.
                        The expiration is identified via expires_in which is in seconds. Be sure to obtain a fresh token sufficiently far in advance to allow for network delays and clock skew.
                    </p>
                    <p>Refer to this documentation page for more information on how to establish the Client Credentials application and authenticate - <HashLink to = {Constants.AUTHENTICATION_PAGE_URL + '#client-credentials-flow'}> Client Credentials Authentication</HashLink></p>
                </section>
                <hr/>
                <section>
                    <h3 id="sending-a-request">Sending a Request</h3>
                    <p>A request may be made with a VIN to check for any Red Light major problems and Yellow Light moderate problems simultaneously or independently. Stoplight may also be configured to only use a single Red Light set of criteria depending upon the use case.</p>
                    <p>Once you have successfully authenticated and have an access token (JWT), you may make a request to receive Stop Light information for a given VIN. Note that the examples below demonstrate the option of sending a single VIN with a single request for Red Light but you also have the option of querying Red Light or Yellow Light if configured.</p>
                    <p>The following is the GraphQL Schema that you may use to make the request to CARFAX Connect:</p>
                    <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(
                            CodeSnippetLanguages.GRAPHQL,
                            "GraphQL",
                            `query {
    stopLight(vin: "VIN123", franchiseNumber: "FRANCHISE123") {
         redLight {
          pass
        }
        vehicle {
          vin
        }
      }
}`
                        )
                    ]}/>
                    <p>You may use the following cURL to send an HTTP request to receive Stoplight information for a given VIN:</p>
                    <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(CodeSnippetLanguages.MARKUP, 'cURL',
                            `curl --request POST \\
--url https://connect.carfax.com/v1/graphql \\
--header 'Authorization: Bearer <access_token>' \\
--header 'Content-Type: application/json' \\
--data '{"query":"query {\\n\\tstopLight(vin: \\"VIN123\\", franchiseNumber: \\"FRANCHISE123\\") {\\n redLight{\\n pass\\n }\\n vehicle{\\n vin\\n\\ }\\n }\\n}"}'`)
                    ]}/>
                    <p>The following is a sample response in JSON:</p>
                    <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(
                            CodeSnippetLanguages.GRAPHQL,
                            "JSON",
                            `{
    "data": {
      "stopLight": {
        "redLight": {
          "pass": true
        },
        "vehicle": {
          "vin": "VIN123"
        }
      }
    }
}`
                        )
                    ]}/>
                    <p>Errors may occur if a request is missing the franchise ID for the dealer or if the franchise ID is associated to a non-Advantage dealer account such as the example below. For a list of all possible error codes please see the <HashLink to = {Constants.ERROR_HANDLING_PAGE_URL + "#error-codes"}> Error Codes</HashLink> table.</p>
                    <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(
                            CodeSnippetLanguages.GRAPHQL,
                            "JSON",
                            `{
    "errors": [
        {
            "message": "Exception while fetching data (/stopLight) : Stoplight is only available for Advantage dealers.",
            "locations":[
             {
                "line":2,
                "column": 1
             }
            ],
            "path":[
                "stopLight"
            ],
            "extensions": {
                "displayableErrorMessage": "Feature only available for CARFAX Advantage dealers. Please contact your CARFAX Representative to upgrade your account.",
                "requestId": "abc01ef-2345-67gh-90ij-1k2l3456m78",
                "errorCode": "STOPLIGHT_NOT_ADVANTAGE",
                "vin": "VIN123",
                "classification": "DataFetchingException"
            }
        }
    ],
    "data": {
        "stopLight": null
    }
}`
                        )
                    ]}/>
                    <p>The expected use case is for a single VIN to be queried but note that Connect supports batch requests as outlined in the <HashLink to = {Constants.SEND_QUERIES_PAGE_URL + "#batch-requests"}> Batch Requests</HashLink> page. If using batch requests, note that 25 queries in a single batch request is the maximum for Stoplight to ensure optimal performance.</p>
                </section>
                <hr/>
                <section>
                    <h3 id="oem-carfax-branding">CARFAX Branding</h3>
                    <p>All references to CARFAX throughout partner applications should always be in all caps.  To integrate OEM Stoplight in a dealer facing tool it is recommended to use the following messages.  A long and short version are listed.  Either may be used depending upon available space.</p>
                    <ul>
                        <li>Stoplight returns "pass": true, render "Vehicle is eligible to be certified based on meeting [insert OEM name]'s defined CARFAX Vehicle History criteria."</li>
                        <li>Stoplight returns "pass": false, render "Vehicle is ineligible to be certified based on not meeting [insert OEM name]'s defined CARFAX vehicle history criteria."</li>
                    </ul>
                    <p>Or</p>
                    <ul>
                        <li>Stoplight returns "pass": true, render "[insert OEM name] CPO Eligible per CARFAX Vehicle History"</li>
                        <li>Stoplight returns "pass": false, render "[insert OEM name] CPO Ineligible per CARFAX Vehicle History"</li>
                    </ul>
                    <p>Please do not deploy CARFAX Connect to production until a demo has been conducted with your Account Manager.</p>
                </section>
                <h1 id="oemIcr">OEM Instant CARFAX Report</h1>
                <section>
                    <h3 id="instant-carfax-report">Instant CARFAX Report</h3>
                    <p>An Instant CARFAX Report (ICR) is a publicly available CARFAX Report paid for by a dealer or Certified Preowned partner.
                        ICRs become available when a partner reports to CARFAX that a vehicle is for sale by a dealer with an active CARFAX subscription.
                        If provisioned by your account manager, CARFAX Advantage dealers may receive Value Badges on their ICRs and your site.
                        All dealers receive attribution on the ICR showing the dealership name, address, phone number, etc. </p>
                    <p>The ICR is generated based on dealer/VIN combinations from inventory files sent to CARFAX, including Certified Pre-Owned inventory.
                        CARFAX Connect is used to retrieve all available ICRs using the OEM franchise ID for each dealer.
                        If your particular OEM partnership provides for ICRs on inventory where a dealer has not run a report Connect will still return the ICR.
                        Your account manager will provide separate instructions for submitting inventory files.
                        As an OEM consumer facing partner you may too be provisioned with the means to post CARFAX 4 Pillar data and Snapshot.
                        Details on these features may be found on the <HashLink to = {Constants.CONSUMER_PAGE_URL + "#consumer-partner"}> Consumer Partner</HashLink> page.</p>
                    <p>An ICR may not be available if the report has not been run by a dealer, the franchise ID does not match or a dealer's account is not active or valid.
                        While the CARFAX Report has a lifespan of up to 150 days the <strong>ICR URLs expire after seven days for security purposes</strong>.
                        It is recommended that all VINs on your site be refreshed nightly to ensure the badges are updated but if you are caching any badges/links, be sure to refresh before the <code>expiresAt</code> timestamp.
                        ICRs may stop being available prior to the URL expiration time if the selling dealer asks us to remove it, the partner stops reporting that the vehicle is for sale, or the report expires.
                        Should the ICR become unavailable but the link remain online a user opening it will be redirected to a CARFAX Record Check where the report may be purchased.</p>
                </section>
                <section>
                    <h3 id="ada-compliance">ADA Compliance / Accessibility</h3>
                    <p>CARFAX is committed to making our products accessible to everyone including people with disabilities.
                        We are continuously improving our sites and products to follow the Web Content Accessibility Guidelines (WCAG).
                        We request that our partners abide by the guidelines put forward through WCAG. In doing so, we ask that all logos displayed on your sites and products are properly coded to meet the standards of WCAG.
                        The valueBadgeAltText value in the Connect response provides the alternate text for all logos that can be displayed.
                        Text should be coded as ALT="CARFAX 1-Owner Great Value Logo" for example.</p>
                </section>
                <section>
                    <h3 id="oem-icr-api-schema">API Schema</h3>
                    <p>
                        For the purposes of this guide, the following Schema will be used:
                        <br/>
                        <CollapsibleContent content={
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.GRAPHQL,
                                "GraphQL",
                                `extend type Query {
    cpoIcr(icrInput: IcrInput): IcrResult
}
 
# Parameters required to locate an Instant CARFAX Report
input IcrInput {
    # VIN of the vehicle
    vin: Vin!
 
    # Dealer's franchise ID
    franchiseId: String!
}
 
# Interface representing the result of an Instant CARFAX Report query, whether the report is available or not.
# If the report is available, the concrete type will be IcrAvailable; otherwise, it will be IcrNotAvailable.
interface IcrResult {
    carfaxLink: CarfaxLink!
    
    franchiseId: String!
}
 
# Link to the CARFAX report or purchase page (record check) if report not available
interface CarfaxLink {
    # CARFAX web page
    url: Url!
 
    # Image that can be displayed as the link
    iconUrl: Url!
}
 
# Instant CARFAX Report link and related data elements available only when the ICR is available
type IcrAvailable implements IcrResult {
    # Link to the CARFAX report
    carfaxLink: IcrLink!                   
     
    # Dealer's franchise ID
    franchiseId: String!
}
 
# Data that is available when the Instant CARFAX Report is not available
type IcrNotAvailable implements IcrResult {
    # Link for consumer to purchase a CARFAX report (Record Check page)
    carfaxLink: RecordCheckLink!
 
    # Dealer's franchise ID
    franchiseId: String!
}
 
# Link directly to CARFAX report
type IcrLink implements CarfaxLink {
    # CARFAX report
    url: Url!
 
    # Image that can be displayed as the link
    iconUrl: Url!
 
    # Time when the link is no longer valid
    expiresAt: Timestamp!
}
 
# Link for consumer to purchase a CARFAX Report (Record Check page)
type RecordCheckLink implements CarfaxLink {
    # Page where consumer can purchase CARFAX Report
    url: Url!
 
    # Image that can be displayed as the link
    iconUrl: Url!
}
 
# Vehicle Identification Number; 17 uppercase alphanumeric characters
scalar Vin
 
# An absolute URL, with encoding applied as needed
scalar Url
 
# RFC 3339 date & time (an ISO 8601 profile) such as '2019-02-01T13:22:33Z'
scalar RfcTimestamp
 
# Integer in the JavaScript safe range -(2^53 - 1) to 2^53 - 1
scalar IntJs
 
# Seconds represented as an IntJs scalar
scalar Seconds
 
# Milliseconds represented as an IntJs scalar
scalar Milliseconds
 
# Instant in time (not local)
type Timestamp {
    # UNIX timestamp; seconds elapsed since the UNIX epoch, 1970-01-01T00:00:00Z, neglecting leap seconds
    unix: Seconds!
 
    # Milliseconds elapsed since the UNIX epoch, 1970-01-01T00:00:00Z, neglecting leap seconds
    unixMillis: Milliseconds!
 
    # Date-time string in RFC 3339/ISO 8601 format, such as '2019-02-01T13:22:33Z'
    rfc: RfcTimestamp!
}`
                            )
                        ]}/>
                        }/>
                    </p>
                </section>
                <section>
                    <h3 id={"oem-icr-prerequisites"}>Prerequisites</h3>
                    <p>
                        Before you can authenticate and start running queries on CARFAX Connect, you must have
                        a <strong>Client Credentials Application</strong> set up in the Partner Portal.
                        Log in to the CARFAX Partner Portal using your developer credentials.
                        You will need to retrieve the Client ID and Client Secret of a Client Credentials application.
                        <ul>
                            <li>
                                If you do not have a Client Credentials application assigned, you can create one using
                                the New Application button.
                                A popup will appear, allowing you to name the new application.
                            </li>
                        </ul>
                    </p>
                    <p className={"text-center"}>
                        <img
                            src={Auth0App}
                            width="647px"
                            alt="Partner Portal: Applications Screen"
                        />
                    </p>
                    <ul>
                        <li>
                            Upon clicking Create, the new application will appear in your list of applications.
                        </li>
                    </ul>
                </section>
                <section>
                    <h3 id="step-1-authenticate-with-carfax">Step 1 - Authenticate with CARFAX</h3>
                    <p>To get started a lead developer will receive an invitation to the Connect Partner Portal as noted on the <HashLink to = {Constants.AUTHENTICATION_PAGE_URL}> Authentication</HashLink> page.</p>
                    <p>Once you have access to the Partner Portal, create a Client Credentials application. With the Client Credentials application built, you next need to authenticate to receive an access token (JWT). This token will allow you to make requests to CARFAX Connect in the form of GraphQL queries to receive the ICR link, badges, alt text, etc. for a given VIN.</p>
                    <p><strong>IMPORTANT:</strong> An access token once obtained is valid for 24 hours and should be reused until it expires. Please do not fetch a new access token with each request. If coded properly we would expect to see one refresh per day if calling from a single machine or perhaps as many as 10 if using distributed machines to call Connect. The expiration is identified via expires_in which is in seconds. Be sure to obtain a fresh token sufficiently far in advance to allow for network delays and clock skew.</p>
                    <p>Refer to the <HashLink to = {Constants.AUTHENTICATION_PAGE_URL + "#client-credentials-flow"}> Client Credentials Authentication</HashLink> page for more information on how to establish the Client Credentials application and authenticate.</p>
                </section>
                <section>
                    <h3 id={"step-2-oem-icr-access-token"}>Step 2 - Get an Access Token</h3>
                    <p>
                        CARFAX Connect follows the OAuth 2.0 authentication process. You'll be using the Client
                        Credentials flow to get an Access Token.
                        Use your Client ID and Client Secret to retrieve an access token with an HTTP POST request
                        to <i>
                        https://auth.carfax.com/oauth/token</i>. You can use the following cURL to request an access
                        token.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(CodeSnippetLanguages.MARKUP, 'cURL',
                                `curl -XPOST \\
    -H "Content-type: application/json" \\
    -d '{"client_id":"YOUR_CLIENT_ID","client_secret":"YOUR_CLIENT_SECRET","audience":"https://connect.carfax.com","grant_type":"client_credentials"}' 'https://auth.carfax.com/oauth/token'
`)
                        ]}/>
                    </p>
                    <p>The response will be similar to the response below. As you can see your access token is
                        under <i>access_token</i> field.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(CodeSnippetLanguages.JSON, 'JSON',
                                JSON.stringify(
                                    {
                                        "access_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9....",
                                        "scope": "read:client_grants create:client_grants ... ",
                                        "expires_in": 86400,
                                        "token_type": "Bearer"
                                    }, null, 4
                                ))
                        ]}/>
                    </p>

                </section>
                <section>
                    <h3 id={"step-3-oem-icr-send-request"}>Step 3 - Send a Request</h3>
                    <p>
                        Use the cpoIcr query to obtain a link to the ICR. This query returns the IcrResult interface type.
                        If the ICR is available, the concrete type will be IcrAvailable, which includes the ICR link and other data as provisioned.
                        To display the ICR link on a web page, use the image provided in the iconUrl field. The URL returned may be one of the eight varieties depending on whether you are provisioned with CARFAX Value Badges.
                        For example, qualifying vehicles display a one-owner badge when the vehicle has one prior owner. The image is an SVG, so you can scale it to fit your layout.
                    </p>
                    <p>Here is an example query that obtains the ICR URL only when the ICR is available:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.GRAPHQL,
                                "GraphQL",
                                `query($icrInput: IcrInput!) {
    cpoIcr(icrInput: $icrInput) {
        ... on IcrAvailable {
            carfaxLink {
                url
                iconUrl
                valueBadgeAltText
                expiresAt {
                    rfc
                    unix
                    unixMillis
                }
            }
            snapshotKey
        }
    }
}`
                            )
                        ]}/>
                    </p>
                    <p>This query uses an <a href="https://graphql.org/learn/queries/#inline-fragments"
                        target="_blank"
                        rel="noopener noreferrer">
                        Inline Fragment
                    </a> to ask for the <code>carfaxLink</code> only when the icr field returns the <code>IcrAvailable</code> type. If the ICR is not available, the type returned is <code>IcrNotAvailable</code>, and the contents of the inline fragment block are ignored.</p>
                    <p>The example query uses the RFC 3339/ISO 8601 human readable representation of the <code>expiresAt</code> timestamp. The <code>Timestamp</code> type also offers UNIX time as seconds or milliseconds, which is easier to parse in many programming languages.</p>
                    <p>Variables for the example query:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify(
                                    {
                                        icrInput: {
                                            vin: "3FMDK4JCXDBE32612",
                                            franchiseId: "TESTID",
                                        },
                                    }, null, 4
                                )
                            )
                        ]}/>
                    </p>
                    <p>The <code>cpoIcr</code> query has one argument, of type <code>IcrInput</code>. You can see the 2 properties of this type in the schema browser.</p>
                    <p>Sample result when ICR is available:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify(
                                    {
                                        data: {
                                            cpoIcr: {
                                                carfaxLink: {
                                                    url:
                                                        "https://carfax.com/VehicleHistory/ar20/pLq9smCzuXn0",
                                                    iconUrl:
                                                        "https://partnerstatic.carfax.com/img/valuebadge/showme.svg",
                                                    valueBadgeAltText:
                                                        "Show Me the CARFAX Badge",
                                                    expiresAt: {
                                                        rfc: "2024-01-01T00:00:00.000Z",
                                                        unix:1704085200,
                                                        unixMillis: 1704085200000
                                                    },
                                                },
                                                snapshotKey: "p5lI0fc6F52ATD-ayqZRUze_I30-6NQVyEahpAADvz4fcqX1kP6rNRvuA2JJBhC1ZDrE1dgeV7M1pBTGCWG3rVJDfY2aWSUvAmp0IpeC6tnf1oxHutKkb3s0jeUmrevT_GnG43aWAbyOlTlueofoE8fF",
                                            },
                                        },
                                    }, null, 4
                                )
                            )
                        ]}/>
                    </p>
                </section>
            </div>
        );
    }
}